import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { Col } from "react-bootstrap";
import { images } from "../../../constants";
import Form from "react-bootstrap/Form";
import { Row } from "react-bootstrap";
import BackArrow from "../../backArrow";
import "./transport.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import ClearIcon from "@mui/icons-material/Clear";
import PersonalImage from "../../../helpers/fileUpload";
import { getAsset } from "../../../helpers/helper";
import LocationModal from "../../locationmodal/LocationModal";
import { useSelector } from "react-redux";
import { useLazyGetShopCategoriesQuery } from "../../../features/shop/shopApiSlice";

import TermsModal from "../../modals/TermsModal";
const TransportForm = ({
  updatehandel,
  butn,
  CreateHandler,
  setCreateShop,
  createShop,
  title,
  backurl,
  UpdateShop,
  link,
  id,
  inputtitle,
  PostShopData,
  shopCategory,
  Updatevehicleshop,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
  Shopdatas,
  isUploading,
  uploadProgress,
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [transportc, setTransportc] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const { name: currentUser } = useSelector((state) => state.user);
  const userCity = currentUser?.MCity || currentUser?.address?.city;

  const [mshow, setMshow] = useState(false);
  const [showTermsTrModal, setShowTermsTrModal] = useState(false);
  const [termsAcceptedTr, setTermsAcceptedTr] = useState(false);
  const [termsErrorTr, setTermsErrorTr] = useState(false);
  const handleClose = () => setMshow(false);
  const handleShow = () => setMshow(true);

  // Refs for input fields
  const shopnameRef = useRef(null);
  const shoplicenseRef = useRef(null);
  const shopaddressRef = useRef(null);
  const marketPlaceRef = useRef(null);
  const descriptionRef = useRef(null);

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const ShopHandler = (event) => {
    setCreateShop((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const userCountry = currentUser?.address?.country || "";

  const validationSchema = Yup.object({
    shopname: Yup.string().required("shopname is required*"),
    shopCategory: Yup.string().required("shopCategory is required*"),
    shoplicense: Yup.string()
      .test(
        "shoplicense-validation",
        "Invalid CNIC or Licence Number",
        function (value) {
          const { path, createError } = this;
          if (!value)
            return createError({ path, message: "shoplicense is required*" });

          if (userCountry.toLowerCase() === "pakistan") {
            const cnicRegex = /^(\d{13}|\d{5}-\d{7}-\d{1})$/;
            if (!cnicRegex.test(value)) {
              return createError({
                path,
                message:
                  "Invalid Pakistani CNIC. Format: 13 digits or XXXXX-XXXXXXX-X",
              });
            }
          } else {
            if (value.length < 5) {
              return createError({
                path,
                message:
                  "Invalid Licence Number. Minimum 5 characters required",
              });
            }
          }
          return true;
        },
      )
      .required("shoplicense is required*"),
    shopaddress: Yup.string().required("shopaddress is required*"),
    description: Yup.string().required("description is required*"),
  });

  const [getShopCategories] = useLazyGetShopCategoriesQuery();

  // Shop-level transport categories are type "transportShop" with empty parent.
  // (transportShopItem rows are nested under mid groups, so parentCategory: "" returns none.)
  const HandleCategory = () => {
    getShopCategories({ type: "transportShop", parentCategory: "" })
      .unwrap()
      .then((res) => {
        if (res?.success) {
          setTransportc(res.data.Category);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    HandleCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <TermsModal show={showTermsTrModal} onClose={() => setShowTermsTrModal(false)} formTitle={title || "Transport"} />
      <LocationModal
        mshow={mshow}
        handleClose={handleClose}
        userCity={userCity}
        createShop={createShop}
        setCreateShop={setCreateShop}
      />
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Formik
        enableReinitialize={true}
        initialValues={{
          shopname: createShop?.shopname || "",
          shoplicense: createShop?.shoplicense || "",
          shopaddress: createShop?.shopaddress || "",
          description: createShop?.description || "",
          shopCategory: createShop?.shopCategory || "",
          marketPlace: createShop?.marketPlace || "",
        }}
        validateOnBlur={false}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const mockEvent = { preventDefault: () => {} };
          if (location.pathname === "/create-transport") {
            CreateHandler(mockEvent);
          } else if (butn === "Update") {
            UpdateShop(mockEvent);
          } else if (location.pathname === "/used-vehicle") {
            PostShopData(mockEvent);
          } else if (butn === "update") {
            Updatevehicleshop(mockEvent);
          } else if (location?.pathname === `${link}${id}`) {
            updatehandel(mockEvent);
          }
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          isValid,
          dirty,
        }) => (
          <Row className="transport-form-row">
            <form className="transport-form" onSubmit={handleSubmit}>
              <div className="transport-form-page screenHeight d-flex justify-content-center align-items-center">
                <div className="transport-form-card Form-Shadow col-lg-6 col-md-6 col-sm-8 col-xs-12 pb-3">
                  <div className="arrowback">
                    <BackArrow
                      back={backurl}
                      black="black"
                      mystyle="p-1 ps-4"
                    />
                  </div>
                  <div className="ps-5 pe-3 pt-4">
                    <div>
                      <h4 className="createHeading">{title}</h4>
                    </div>
                    <Row className="pt-3 ps-1 pe-3">
                      <Col lg="6" className="d-flex flex-column">
                        <label className="custm-lble-2 pb-2">
                          {inputtitle}
                        </label>
                        <input
                          className="input-style"
                          placeholder="Name"
                          value={createShop?.shopname || ""}
                          name="shopname" // Non-standard name
                          readOnly={
                            location.pathname === `/usedvehicle-update/${id}`
                          }
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                          ref={shopnameRef}
                        />
                        {errors.shopname && touched.shopname ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shopname}
                            </p>
                          </div>
                        ) : null}
                      </Col>
                      <Col lg="6">
                        {location.pathname === "/used-vehicle" ||
                        location.pathname === `/usedvehicle-update/${id}` ? (
                          <>
                            <label className="custm-lble-2 pb-1">
                              Select Category
                            </label>
                            <Form.Select
                              className="input-style"
                              aria-label="Default select example"
                              name="shopCategory" // Non-standard name
                              value={createShop?.shopCategory || ""}
                              onChange={(e) => {
                                ShopHandler(e);
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              autoComplete="off"
                            >
                              <option value="">Select-Category</option>
                              {shopCategory?.map((category) => (
                                <option
                                  key={category._id}
                                  value={category?._id}
                                >
                                  {category?.name}
                                </option>
                              ))}
                            </Form.Select>
                            {errors.shopCategory && touched.shopCategory ? (
                              <div>
                                <p className="error_text_color">
                                  {errors.shopCategory}
                                </p>
                              </div>
                            ) : null}
                          </>
                        ) : (
                          <>
                            <Form.Label className="custm-lble-2 mb-1">
                              Select Category
                            </Form.Label>
                            <Form.Select
                              className="input-style"
                              aria-label="Default select example"
                              value={createShop?.shopCategory || ""}
                              name="shopCategory" // Non-standard name
                              onChange={(e) => {
                                ShopHandler(e);
                                Shopdatas(e);
                              }}
                              onBlur={handleBlur}
                              onClick={HandleCategory}
                              autoComplete="off"
                            >
                              <option value="">Select Category</option>
                              {transportc?.map((e) => (
                                <option
                                  key={e._id}
                                  value={`${e?._id}.${e?.name}`}
                                >
                                  {e?.name}
                                </option>
                              ))}
                            </Form.Select>
                            {errors.shopCategory && touched.shopCategory ? (
                              <div>
                                <p className="error_text_color">
                                  {errors.shopCategory}
                                </p>
                              </div>
                            ) : null}
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-3 ps-1 pe-3">
                      {location.pathname === "/used-vehicle" ||
                      location.pathname === `/usedvehicle-update/${id}` ? (
                        <Col lg="6" className="d-flex flex-column">
                          <label className="custm-lble-2 pb-2">
                            Market Place
                          </label>
                          <input
                            className="input-style"
                            placeholder="Market Place"
                            value={createShop?.marketPlace || ""}
                            name="marketPlace" // Non-standard name
                            onChange={(e) => {
                              ShopHandler(e);
                            }}
                            onBlur={handleBlur}
                            autoComplete="off"
                            ref={marketPlaceRef}
                          />
                        </Col>
                      ) : null}
                      <div
                        lg="6"
                        className={`d-flex flex-column ${
                          location.pathname === "/used-vehicle" ||
                          location.pathname === `/usedvehicle-update/${id}`
                            ? "col-lg-6"
                            : "col-12"
                        }`}
                      >
                        <label className="custm-lble-2 pb-2">
                          CNIC or Licence Number
                        </label>
                        <input
                          value={createShop?.shoplicense || ""}
                          name="shoplicense" // Non-standard name
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          className="input-style"
                          placeholder="Licence Number/CNIC"
                          autoComplete="off"
                          ref={shoplicenseRef}
                        />
                        {errors.shoplicense && touched.shoplicense ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shoplicense}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </Row>
                    <Row className="pt-3 ps-1 pe-3">
                      <Col md={12} lg={12} xl={12}>
                        <Form.Label className="custm-lble-2 pt-2">
                          Shop Address
                        </Form.Label>
                        <Form.Control
                          placeholder="Add Address with maps"
                          className="input-style"
                          name="shopaddress" // Non-standard name
                          value={createShop?.shopaddress || ""}
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                          ref={shopaddressRef}
                        />
                        <div className="position-relative">
                          <img
                            onClick={handleShow}
                            className="iMg cursor_P"
                            src={images.FindClinic}
                            alt=""
                          />
                        </div>
                        {errors.shopaddress && touched.shopaddress ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shopaddress}
                            </p>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <div className="ps-1 pe-3">
                      <div className="d-flex flex-column pt-1">
                        <label className="custm-lble-2 pb-2">Description</label>
                        <textarea
                          placeholder="Description"
                          className="input-style pt-1 ps-2 pb-5 pe-2"
                          value={createShop?.description || ""}
                          name="description" // Non-standard name
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                          ref={descriptionRef}
                        />
                        {errors.description && touched.description ? (
                          <div>
                            <p className="error_text_color">
                              {errors.description}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <Col>
                      <Row>
                        <Col lg="9" className="me-auto">
                          <Row>
                            <Col lg={3} className="mt-2 ms-1">
                              <Card
                                style={{
                                  width: "6rem",
                                  height: "6rem",
                                  position: "relative", // ✅ to position loader
                                }}
                                {...getRootProps()}
                                className="dropzone"
                              >
                                {/* Show loader if uploading */}
                                {isUploading ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      background: "rgba(255,255,255,0.7)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    <div
                                      className="spinner-border text-primary"
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                      }}
                                      role="status"
                                    ></div>
                                    <small className="mt-1">
                                      {uploadProgress}%
                                    </small>
                                  </div>
                                ) : (
                                  <>
                                    <Card.Img
                                      className="imet-fit"
                                      src={images.AddImage}
                                    />
                                    <Card.Body>
                                      <input
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        {...getInputProps()}
                                        multiple
                                        autoComplete="off"
                                      />
                                    </Card.Body>
                                  </>
                                )}
                              </Card>
                            </Col>

                            {displayimg?.length > 0 && (
                              <Col
                                lg={7}
                                className="transport-form-image-list mt-1 d-flex"
                              >
                                {displayimg.map((image, index) => (
                                  <Card
                                    key={index}
                                    className="mt-1"
                                    style={{
                                      width: "6rem",
                                      height: "6rem",
                                      border: "2px solid",
                                      position: "relative",
                                    }}
                                  >
                                    <Card.Img
                                      className="imet-fit upload-img mt-0"
                                      src={getAsset(image)}
                                      alt=""
                                      crossOrigin="anonymous"
                                    />
                                    <div
                                      className="close-btnone"
                                      onClick={() => removeImage(index)}
                                    >
                                      <ClearIcon />
                                    </div>
                                  </Card>
                                ))}
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <div className="mt-3 mb-2 ps-1">
                     <div className="d-flex align-items-center gap-2">
                       <input
                         type="checkbox"
                         id="terms-checkbox-trform"
                         checked={termsAcceptedTr}
                         onChange={(e) => { setTermsAcceptedTr(e.target.checked); if(e.target.checked) setTermsErrorTr(false); }}
                         style={{ cursor: "pointer", width: "16px", height: "16px", flexShrink: 0 }}
                       />
                       <label htmlFor="terms-checkbox-trform" style={{ margin: 0, fontSize: "0.85rem", cursor: "pointer" }}>
                         I agree to the{" "}
                         <span
                           onClick={(e) => { e.preventDefault(); setShowTermsTrModal(true); }}
                           style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                         >
                           Terms &amp; Conditions
                         </span>
                       </label>
                     </div>
                     {termsErrorTr && (
                       <p className="error_text_color" style={{ fontSize: "0.8rem", marginTop: "4px", marginBottom: 0 }}>
                         Please agree to the Terms &amp; Conditions before continuing.
                       </p>
                     )}
                   </div>
                    <div className="btns pe-4 pb-3">
                      <button
                        type="button"
                        className="btn1"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <Button
                        className="btn2 p-1"
                        variant="primary"
                        type="submit"
                      >
                        {butn}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Row>
        )}
      </Formik>
    </>
  );
};

export default TransportForm;
